import { RoutesEnum } from '../../../../../shared/models/routes.enum';
import { MenuItem } from '../models/menu.interface';

export const LinksGroup1: MenuItem[] = [
  { label: 'AKTUALNOŚCI', link: 'https://ligapadla.pl/aktualnosci/', isExternal: true },
  { label: 'TURNIEJE', link: RoutesEnum.Tournaments },
  { label: 'RANKINGI', link: RoutesEnum.Ranking },
  { label: 'JAK GRAMY?', link: 'https://ligapadla.pl/jak-gramy/', isExternal: true },
  // { label: 'WSPÓŁPRACA', link: 'https://ligapadla.pl/wspolpraca/', isExternal: true },
];

export const LinksGroup2: MenuItem[] = [
  { label: 'CO TO PADEL?', link: 'https://zagrajwpadla.pl/co-to-padel/', isExternal: true, isTargetBlank: true },
  { label: 'KORTY DO PADLA', link: 'https://zagrajwpadla.pl/', isExternal: true, isTargetBlank: true },
  { label: 'KUP SPRZĘT DO PADLA', link: 'https://babolat-tenis.pl/225-padel/', isExternal: true, isTargetBlank: true },
];

export const SocialsGroup: MenuItem[] = [
  {
    icon: 'pi pi-facebook',
    link: 'https://www.facebook.com/profile.php?id=61569376677294',
    isExternal: true,
    isTargetBlank: true,
  },
  { icon: 'pi pi-youtube', link: 'https://www.youtube.com/', isExternal: true, isTargetBlank: true },
  { icon: 'pi pi-instagram', link: 'https://www.instagram.com/ligapadla.pl/', isExternal: true, isTargetBlank: true },
  // { icon: 'pi pi-tiktok', link: 'https://www.linkedin.com/', isExternal: true, isTargetBlank: true },
  // { icon: 'pi pi-twitter', link: 'https://twitter.com/', isExternal: true, isTargetBlank: true },
];
